/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

import Modal from "../components/Modal";

import { useModalStore } from "../stores/hooks";

function AlertModal({
  title,
  message,
  submitText = "닫기",
  onSubmit = () => {},
}) {
  const { closeModal } = useModalStore();

  const handleSubmit = () => {
    onSubmit();
    closeModal();
  };

  return (
    <Modal>
      <div className="">
        <div className="pt-20 px-15 mb-20">
          {title && (
            <h5 className="text-18 font-bold text-left mb-10">{title}</h5>
          )}
          <div className={`text-16 ${title ? "text-left" : "text-center"}`}>
            {message.split("\n").map((line, index) => (
              <div key={index} className="min-h-24">
                {line}
              </div>
            ))}
          </div>
        </div>
        <div className="flex justify-end items-center border-t-1 border-gray-8">
          <button
            type="button"
            className="text-16 flex-1 p-10"
            onClick={handleSubmit}
          >
            {submitText}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default AlertModal;
